import { render } from "./ReportsRow.vue?vue&type=template&id=b90d1dc2&scoped=true"
import script from "./ReportsRow.vue?vue&type=script&lang=js"
export * from "./ReportsRow.vue?vue&type=script&lang=js"

import "./ReportsRow.vue?vue&type=style&index=0&id=b90d1dc2&scoped=true&lang=css"

import exportComponent from "C:\\job\\ems-ISO-final\\frontend_ems\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b90d1dc2"]])

export default __exports__